// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"2eacaf4c","979":"6c50fd03"}[chunkId] + ".chunk.css";
};